'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; /**
                                                                                                                                                                                                                                                                               * @fileOverview 使用spaui-decorate默认给组件带上.decorate的方法
                                                                                                                                                                                                                                                                               * @author kirkzheng
                                                                                                                                                                                                                                                                               */


var _spauiDevtool = require('@tencent/spaui-devtool');

exports.default = function () {
    var infoData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var name = infoData.componentName || infoData.name || '';
    var version = infoData.componentVersion || infoData.version || '';
    var $componentDom = null,
        cssVersion = '';

    if (typeof _spauiDevtool.getDevToolSwitchStatus !== 'undefined' && (0, _spauiDevtool.getDevToolSwitchStatus)() && name && version && (typeof document === 'undefined' ? 'undefined' : _typeof(document)) === 'object' && document.querySelector) {
        $componentDom = document.querySelector('.' + name);
        if ($componentDom) {
            cssVersion = getComputedStyle($componentDom) && getComputedStyle($componentDom).getPropertyValue('--version');
            if (cssVersion) {
                cssVersion = cssVersion.replace(/_/gi, '.');
            }
            if (version !== cssVersion && '"' + version + '"' !== cssVersion) {
                console.warn('【' + name + '组件】css版本不一致：js版本为' + version + '；css版本为' + cssVersion);
            }
        }
    }
};